window.onload = () => {
  window.onscroll = function(e) { stickyBar(e) };
  
  var navbar = document.getElementById("navbar");
  var header = document.getElementById("header-sticky");
  var footer = document.getElementById("footer-body");
  var minY = navbar.offsetTop - header.offsetHeight;
  var stickyFooter = footer.offsetTop;
  var maxY = stickyFooter + navbar.offsetHeight;
  
  function stickyBar(e) {
    let isAuthenticity = window.location.pathname.includes('autenticidad') ? true : false
    console.log(isAuthenticity)
    console.log(e)
    if (window.pageYOffset >= minY) {
      if (window.pageYOffset <= maxY) {
        if(isAuthenticity){
          let wrapper = navbar.parentElement
          let maxWidth = wrapper.clientWidth
          let section = wrapper.closest('.shopify-section')
          section.nextSibling.style.position = 'relative'
          section.nextSibling.style.backgroundColor = 'white'
          navbar.style.maxWidth = `${parseInt(maxWidth)-30}px`
        }
        navbar.classList.add("sticky");
      }else{
        navbar.classList.remove("sticky");
      }
    } else {
      navbar.classList.remove("sticky");
    }
  }
}